/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_HandynummerInputs */

const de__field_handynummer = /** @type {(inputs: _Field_HandynummerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handynummer (privat)`)
};

/**

* @param {_Field_HandynummerInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_handynummer = /** @type {((inputs?: _Field_HandynummerInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_HandynummerInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_handynummer(inputs)
});